import withClientSideRenderOnly from 'hocs/withClientSideRenderOnly';
import withAfterEventsRendering from 'hocs/withAfterEventsRendering';
import AutoReplenishmentPageContent from 'components/RichProfile/MyAccount/AutoReplenishment/AutoReplenishmentPageContent/AutoReplenishmentPageContent';

export default withAfterEventsRendering(withClientSideRenderOnly()(AutoReplenishmentPageContent), ['UserInfoReady', 'HydrationFinished']);
